<template>
    <v-dialog v-model="dialog" max-width="900" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Equipment relationship'|translate }}
            </v-card-title>
            <v-card-text class="pr-4 pl-4">
                <v-text-field :label="'Type'|translate" v-model="type"></v-text-field>
                <equipment-selector :label="'Equipment 1'|translate" v-model="equip1"></equipment-selector>
                <equipment-selector :label="'Equipment 2'|translate" v-model="equip2"></equipment-selector>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'Equipment')">
                    {{ 'Save'|translate }}
                </v-btn>
                <v-btn @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {putEquipmentRelationship} from '../helper'
import EquipmentSelector from "./EquipmentSelector";

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    components: {EquipmentSelector},
    name: 'EquipmentRelationshipDialog',
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                let newItem=JSON.parse(JSON.stringify(item))
                this.equipment_relationship_id = newItem['equipment_relationship_id']
                this.type = newItem['type']
                this.equip1 = this.nameMap[newItem['equip1']]
                this.equip2 = this.nameMap[newItem['equip2']]
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            equipment_relationship_id: null,
            type: null,
            equip1: null,
            equip2: null,
            nameMap:{},
        }
    },
    mounted() {
        let newMappings={}
        for (let equip of Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)){
            newMappings[equip.equipment_id]=equip.equipment_name
        }
        this.nameMap=newMappings
    },
    methods: {
        addParameter() {
            this.config.parameters.push({min:-10, max:10, sensor:null})
        },
        removeParameter(index) {
            this.config.parameters.splice(index, 1)
        },
        addCovariant() {
            this.config.covariants.push({sensor:null})
        },
        removeCovariant(index) {
            this.config.covariants.splice(index, 1)
        },
        initializeVar() {
            this.equipment_relationship_id = null
            this.type = null
            this.equip1 = null
            this.equip2 = null
        },
        async addRecord() {
            await putEquipmentRelationship(
                {
                    'equipment_relationship_id': this.equipment_relationship_id,
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'type': this.type,
                    'equip1': this.$store.state.pointsListStore.pointsList.equipment_details[this.equip1].equipment_id,
                    'equip2': this.$store.state.pointsListStore.pointsList.equipment_details[this.equip2].equipment_id,
                }
            )
            this.$emit('doreload')
            this.dialog = false
        }
    },
}
</script>

<style scoped>

</style>
